export const TOTAL_VIDEO_CONTROLLER = 'credits.video.total';
export const USED_VIDEO_CONTROLLER = 'credits.video.used';
export const TOTAL_MINUTES_CONTROLLER = 'credits.minutes.total';
export const USED_MINUTES_CONTROLLER = 'credits.minutes.used';
